  //////////////////////////////////
  ///////// Print Helper //////////
  ////////////////////////////////

  export function printAll(sessionOutput, alreadyPrinted){
    // 'printed' is to separate intermediate_labels key from new labels one.
    var printed = alreadyPrinted ? 'alreadyPrinted' : '';
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    for(var i=0; i < sessionOutput.length ; i++){
      var content = document.getElementById("toPrint" + i + printed);
      pri.document.write(content.innerHTML);
    }
    pri.document.close();
    setTimeout(() => {
      pri.focus();
      pri.print();
    },50)
  }

  export function printLabel(index, alreadyPrinted) {
    // 'printed' is to separate intermediate_labels key from new labels one.
    var printed = alreadyPrinted ? 'alreadyPrinted' : '';
    var content = document.getElementById("toPrint" + index + printed);
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    setTimeout(() => {
      pri.focus();
      pri.print();
    },50)
  }
